import React, { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EventList from './EventList';
import AttendanceManager from './AttendanceManager';
import * as api from './api';
import './EventManager.css';

const EventManager = ({ token }) => {
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [view, setView] = useState('events'); // 'events' | 'attendance'

    api.setToken(token);

    const handleManageAttendance = (event) => {
        setSelectedEvent(event);
        setView('attendance');
    };

    const handleBackToEvents = () => {
        setSelectedEvent(null);
        setView('events');
    };

    return (
        <div className="em-container">
            <div className="em-header">
                <h1 className="em-title">Event Manager</h1>
                {view === 'attendance' && selectedEvent && (
                    <button className="em-back-btn" onClick={handleBackToEvents}>
                        ← Back to Events
                    </button>
                )}
            </div>

            {view === 'events' && (
                <EventList
                    token={token}
                    onManageAttendance={handleManageAttendance}
                />
            )}

            {view === 'attendance' && selectedEvent && (
                <AttendanceManager
                    token={token}
                    event={selectedEvent}
                />
            )}

            <ToastContainer position="bottom-right" autoClose={3000} />
        </div>
    );
};

export default EventManager;
